import { useEffect, useState } from "react";
import { NXDelete, NXPlus } from "../../../icons";
import NxtbnDrawer from "../../drawer";
import { useDeleteConfirmation } from "../../common";
import useApi from "../../../api";
import { toast } from "react-toastify";
import countryList from "react-select-country-list";
import ShippingRateForm from "./ShippingRateForm";



interface ShippingMethodViewPops {
  id: any;
  isOpen: any;
  onClose: ()=>void;
}

function ShippingMethodView({
  id,
  isOpen,
  onClose,
}: ShippingMethodViewPops) {

  const [shippingMethod, setShippingMethod] = useState<any>();
  const [openShippingRateForm, setOpenShippingRateForm] = useState<boolean>(false)
  const [edit, setEdit] = useState<any>(null)

  const api = useApi();

  const country = countryList().getData()
  const { handleDelete } = useDeleteConfirmation();

  const getDetailShippingMethod = () => {
    api.getShippingMethod(id).then((response: any) => setShippingMethod(response)).catch((error: any) => toast.error("Error Fetch Shipping Rate !!"));
  };

  useEffect(() => {
    getDetailShippingMethod();
  }, [id]);


  return (
    <NxtbnDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Shipping Method"
    >
      <div className="m-4">
        <div className="border-b pb-4">
          <div className="mt-4 flex items-center gap-3">
            <h3>Name:</h3>
            <span>{shippingMethod?.name}</span>
          </div>
          <div className="mt-4 flex items-center gap-3">
            <h3>Description:</h3>
            <span>{shippingMethod?.description}</span>
          </div>
          <div className="mt-4 flex items-center gap-3">
            <h3>Carrier:</h3>
            <span>{shippingMethod?.carrier}</span>
          </div>
        </div>
        <div className="mt-4">
          <div className="flex justify-between items-center">
            <h3>Shipping Method Rate</h3>
            <button
              onClick={()=>setOpenShippingRateForm(true)}
              className="my-2 flex items-center gap-2 bg-primary-400 py-2 px-5 text-white rounded-md hover:bg-primary-500 transition-all duration-150 ease-linear"
            >
              <NXPlus className="h-5 w-5" />
              Add Shipping Rate
            </button>
          </div>
          {shippingMethod?.rates.length > 0 && (
          <div className="w-full overflow-x-auto">
            {shippingMethod?.rates.map((item: any, index: number) => (
              <div key={index} className="p-4 border shadow-lg rounded-lg mb-4 flex justify-between items-start">
                <div>
                  <div><strong>ID: </strong>{item?.id}</div>
                  <div><strong>Country: </strong>{item?.country}</div>
                  <div><strong>Region:  </strong>{item?.region}</div>
                  <div><strong>City: </strong>{item?.city}</div>

                  <div><strong>Weight Min: </strong>{item?.weight_min}</div>
                  <div><strong>Weight Max: </strong>{item?.weight_max}</div>
                  <div><strong>Rate: </strong>{item?.rate}</div>
                  <div><strong>Incremental Rate: </strong>{item?.incremental_rate}</div>
                 
                </div>
                <div className="flex gap-3">
                  <button
                    onClick={()=>setEdit(item)}
                    className="text-primary-400 hover:underline font-bold"
                  >
                    Edit
                  </button>
                  <button 
                    onClick={(e)=>{
                      e.preventDefault()
                      handleDelete(
                        item.id,
                        "Shipping Rate",
                        api.deleteShippingRate,
                        getDetailShippingMethod
                      )
                    }}
                  >
                    <NXDelete className="text-red-600"/>
                  </button>
                </div>
              </div>))}
          </div>)}
          </div>
          
          {openShippingRateForm && 
            <ShippingRateForm 
              isOpen={openShippingRateForm} 
              onClose={()=>setOpenShippingRateForm(false)}
              shippingMethodId={id}
              refresh={getDetailShippingMethod}
            />}

          {edit && 
            <ShippingRateForm 
              edit={edit} 
              isOpen={edit ? true : false} 
              onClose={()=>setEdit(null)}
              shippingMethodId={id}
              refresh={getDetailShippingMethod}
            />}
          
        </div>
    </NxtbnDrawer>
  );
}

export default ShippingMethodView;
